<template>
  <div class="error-page">
    <div class="top-logo"><img src="../assets/pivo.png" alt="pivo" /></div>
    <div class="main">
      <h1 class="title">{{ title }}</h1>
      <p class="secondary-text">{{ secondaryText }}</p>
      <img src="../assets/pivo_shape.png" alt="pivo_shape" />
      <button
        v-if="tryButton"
        @click="handleTry"
        class="btn-primary"
        type="button"
      >
        TRY AGAIN
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Connection Error",
    },
    secondaryText: {
      type: String,
      default: "No connection found. Click button to try again.",
    },

    tryButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleTry() {
      this.$router.push({ name: "qrcode" });
    },
  },
};
</script>

<style lang="css" scoped>
.error-page .top-logo {
  position: absolute;
  top: 20px;
  left: 20px;
}
.error-page .top-logo img {
  height: 25px;
}
.error-page .main {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  color: #a5adbb;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  height: 70vh;
  width: 95%;
}
.error-page .main .title {
  margin: 0;
  font-size: 40px;
  line-height: 32px;
}

.error-page .main .secondary-text {
  font-size: 36px;
  margin: 0;
  line-height: 49px;
}

.error-page .main .btn-primary {
  border: none;
  padding: 15px 30px;
  border-radius: 30px;
  background-color: #ec2544;
  color: white;
  outline: none;
  cursor: pointer;
}
</style>
